import { memo } from 'react';
import { Route } from 'react-router-dom';

import { AllowRoute } from './auth';
import { WithNotFound } from './errors';
import { Dashboard } from './dashboard';
import { Payments } from './payments';
import { Customers } from './customers';
import { Settings } from './settings';
import { Partner } from './partner';
import { Orders } from './orders';
import { PartnerRoute } from './auth/accessToken/Partner';
import { Marketing } from './marketing';
import { Payout } from './payout';
import { Reports } from './reports';

const AppContent = () => (
    <WithNotFound>
        <AllowRoute
            path={`/:accountId/payments`}
            component={Payments}
            anyOfScopes={[['admin'], ['admin:checkout'], ['read:checkout']]}
        />
        <AllowRoute
            path={`/:accountId/customers`}
            component={Customers}
            anyOfScopes={[['admin'], ['admin:customers'], ['read:customers']]}
        />
        <AllowRoute
            path={`/:accountId/orders`}
            component={Orders}
            anyOfScopes={[['admin'], ['admin:orders'], ['read:orders'], ['admin:shopping'], ['read:shopping']]}
        />
        <AllowRoute
            path={`/:accountId/marketing`}
            component={Marketing}
            anyOfScopes={[['admin'], ['admin:discounts'], ['read:discounts']]}
        />
        <AllowRoute
            path={`/:accountId/payout`}
            component={Payout}
            anyOfScopes={[['read:payout'], ['admin:payout'], ['read:payout:/admin'], ['admin:payout:/admin']]}
        />
        <AllowRoute path={`/:accountId/settings`} component={Settings} anyOfScopes={[['admin'], ['admin:accounts']]} />
        <AllowRoute
            path={`/:accountId/reports`}
            component={Reports}
            anyOfScopes={[['admin'], ['admin:accounts'], ['admin:reports'], ['read:reports']]}
        />
        <PartnerRoute path={`/:accountId/sub-accounts`} component={Partner} />
        <Route path={`/:accountId/`} exact component={Dashboard} />
    </WithNotFound>
);

export default memo(AppContent);
